export default {"src":"/_next/static/media/illustration-dog-happy-blob.fa50c589.svg","height":332,"width":262};